import React from 'react';

import {
  commonFormStylesIdentifier,
  commonPageStylesIdentifier
} from '../constants';
import { routes } from '../routes';
import { isEdgeBrowser } from '../utils/utils';

export const findElementsByIds = ids => {
  let elements = [];
  for (let id of ids) {
    if (document.getElementById(id)) elements.push(document.getElementById(id));
  }
  return elements;
};

export const findElementsByClasses = classes => {
  let elements = [];
  for (let c of classes) {
    if (document.querySelector(`.${c}`))
      elements.push(document.querySelector(`.${c}`));
  }
  return elements;
};

export const onClickIfEnabled = (isEnabled, onClick?) => e =>
  isEnabled ? onClick && onClick(e) : e.preventDefault();

export const withPrefix = prefix => (...params) =>
  params
    .reduce((acc, param) => (param ? acc + ' ' + prefix + param : acc), '')
    .slice(1);

export const formClass = withPrefix(commonFormStylesIdentifier);

export const commonClass = withPrefix(commonPageStylesIdentifier);

export const capitalise = str =>
  str?.length ? str[0].toUpperCase() + str.slice(1) : str;

export const dashboardLinkEnabled = (agentScriptPending, location) =>
  !agentScriptPending ||
  location.pathname !== `${routes.paymentThankYou.url}home`;

export const edgeAriaLabel = text =>
  isEdgeBrowser && <span className="edgeAriaLabel">{text}</span>;
